import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class CurrentLanguageInterceptor implements HttpInterceptor {
    constructor() { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        var language = localStorage.getItem("language") || "zh";
        const headers = req.headers
            .set('Current-Language', language)
            .set('Accept-Language', 'zh-CN,zh;q=0.8');
        const newReq = req.clone({ headers });
        return next.handle(newReq);
    }
}
